// extracted by mini-css-extract-plugin
export var marginNegative = "_7b-5 _7b-3 _7b-1";
export var marginPositive = "_7b-4 _7b-3 _7b-1";
export var modalContent = "_7b-6";
export var samplesTable = "_7b-8";
export var samplesTableContainer = "_7b-7";
export var statBox = "_7b-a";
export var tableCell = "_7b-1";
export var tableCellCenter = "_7b-2 _7b-1";
export var tableCellRight = "_7b-3 _7b-1";
export var tableHeader = "_7b-0";
export var trackingNumber = "_7b-9";